"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var AlarmOnFill = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_AlarmOnFill_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.676.203A3.494 3.494 0 0 0 12.5 0c-1.06 0-2.01.47-2.651 1.215.719.17 1.4.437 2.029.786L13.676.203ZM11.138 2.741A6.95 6.95 0 0 0 8 2a6.965 6.965 0 0 0-4.93 2.03A6.98 6.98 0 0 0 1 9c0 1.128.267 2.194.741 3.138L7.5 6.378V5a.5.5 0 0 1 1 0v.379l2.638-2.638Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.136 15.158 15 .293a.286.286 0 0 0 .009-.009l.137-.138a.5.5 0 0 1 .708.708l-.55.55c.437.584.696 1.31.696 2.096 0 .809-.274 1.553-.735 2.146a8.02 8.02 0 0 0-1.757-2.447l-.707.707A6.982 6.982 0 0 1 15 9a6.985 6.985 0 0 1-2.463 5.33l.817.816a.5.5 0 0 1-.708.708l-.924-.925A6.967 6.967 0 0 1 8 16a6.967 6.967 0 0 1-3.722-1.07l-.924.924a.5.5 0 0 1-.708-.708l.817-.816a7.036 7.036 0 0 1-.557-.529L.854 15.854a.5.5 0 0 1-.718-.696ZM8.5 8.207l-.968.967A.5.5 0 0 0 8 9.5h2.5a.5.5 0 0 0 0-1h-2v-.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.151 1.215A8.017 8.017 0 0 0 .735 5.646 3.5 3.5 0 0 1 6.15 1.215Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_AlarmOnFill_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = AlarmOnFill;
exports["default"] = _default;